import { useContext, useState } from "react";
import { useHistory } from "react-router";

import Layout from "../../../global/component/Genericos/Layout/Layout";
import { GlobalContext } from "../../../global/context/Provider";
import Loading from "../../components/Genericos/Loading/Loading";
import {
  wsGetNotificacion,
  wsPutNotiVisto,
} from "../../context/Actions/notificaciones/notificaciones";
import { PortalContext } from "../../context/Provider";
import BodyNoti from "./BodyNoti/BodyNoti";
import { ContainerNoti } from "./localStyle";
import { filterNotification } from "./NotificationFun";
import TopNoti from "./TopNoti/TopNoti";

const Notificaciones = () => {
  const { authState } = useContext(GlobalContext);
  const { notificacionesState, notificacionesDispatch } =
    useContext(PortalContext);

  // -------------------- Constantes y variables ----------------------------
  const user = authState.auth.data.paciente.nombre;
  let data = notificacionesState?.notificaciones?.data;
  const loading = notificacionesState.notificaciones.loading;
  const history = useHistory();

  // -------------------- Estados ----------------------------
  const filterDataDropDown = [
    { name: "Todos", id: 1 },
    { name: "Sin leer", id: 2 },
    { name: "Leídos", id: 3 },
  ];
  const [localForm, setLocalForm] = useState({ filtro: "Sin leer" });

  // Hacer el filtro
  data = filterNotification(data, localForm.filtro);

  // Marcar como leído
  const next = () => {
    wsGetNotificacion()(notificacionesDispatch);
  };
  const handleClickButoon = (idNotificacion, notificacion, vista) => {
    if (!vista) wsPutNotiVisto(idNotificacion, next)(notificacionesDispatch);
    if (notificacion?.link?.url) {
      history.push(notificacion.link.url);
    }
  };
  return (
    <Layout positionSidebar={12} origen={"Información"}>
      {notificacionesState?.notificaciones?.loading ? (
        <Loading
          dataLoading={true}
          color="c-white"
          descripcion={"Cargando Notificaciones ..."}
        />
      ) : (
        <ContainerNoti>
          <TopNoti
            user={user}
            data={data.noleidos}
            filterDataDropDown={filterDataDropDown}
            localForm={localForm}
            setLocalForm={setLocalForm}
            historial={data.leidos}
          />
          <div className="line-separation"></div>
          <BodyNoti
            handleClickButoon={handleClickButoon}
            loading={loading}
            data={data.noleidos}
            noleidos={data.leidos}
          />
        </ContainerNoti>
      )}
    </Layout>
  );
};
export default Notificaciones;
